import { animations } from './animations';

export const transitions = {
  all: `all ${animations.durations.normal} ${animations.easings.easeInOut}`,
  colors: `color ${animations.durations.fast} ${animations.easings.linear}, background-color ${animations.durations.fast} ${animations.easings.linear}, border-color ${animations.durations.fast} ${animations.easings.linear}`,
  opacity: `opacity ${animations.durations.fast} ${animations.easings.linear}`,
  transform: `transform ${animations.durations.normal} ${animations.easings.bounce}`,
  shadow: `box-shadow ${animations.durations.fast} ${animations.easings.easeOut}`,
};

export default transitions;
